import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardContent from "@/shared/ui/SogCardContent.vue";


import notificationService from "@/shared/services/NotificationService";
import BordereauListComponent from "@/modules/WakamBordereau/components/BordereauListComponent.vue";
import {computed, onMounted, reactive, ref} from "vue";
import {RouteLocationNormalizedLoaded, useRoute} from "vue-router";
import progressService from "@/shared/services/ProgressService";
import {ProgressInfo} from "@/shared/model/ProgressInfo";
import apiFile from "@/shared/services/apiFile";
import SogGrid from "@/shared/ui/SogGrid.vue";
import apiBordereau from "@/modules/WakamBordereau/api";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import BordereauPeriod from "@/shared/model/BordereauPeriod";
import SogProgressInfoComponent from "@/shared/ui/SogProgressInfoComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PeriodListPage',
  setup(__props) {


const _id = ref("");
const _listComponent = ref<InstanceType<typeof SogGrid> | null>(null)
const _bordereauId = ref("bordereau_wakam")
const _items = reactive([{id: "bordereau_wakam", value: "Short-MTPL"},
  {
  id: "bordereau_wakam_us_nato",
  value: "US-NATO"
  },
  {
    id: "hiscox",
    value: "Lokky/Hiscox (temporel)"
  },
]);
const _selectedPeriod = ref<BordereauPeriod | undefined>(undefined)
const _params = reactive({ftp: false, periodId: ""})

function p_init(route: RouteLocationNormalizedLoaded) {
  _id.value = route.params.id as string;
}

const _progressInfo = ref<ProgressInfo | undefined>(undefined)

async function onExport(csv: boolean, ftp: boolean) {
  if (!_selectedPeriod.value)
    return
  _params.ftp = ftp
  _params.periodId = _selectedPeriod.value.id ?? "";
  const partnerships = _bordereauId.value === "bordereau_wakam" ? ['178030101', '178030104'] : _bordereauId.value === "bordereau_wakam_us_nato"? ['178030103']:[_bordereauId.value];
  const id = await apiBordereau.initExport(_selectedPeriod.value.id ?? "", partnerships, _bordereauId.value === "bordereau_wakam", csv, ftp)
  if (id) {
    await progressService.addToGroup([id], false, onProgressRefresh)
  }
}


onMounted(async () => {
  const route = useRoute();
  await p_init(route)
  //console.log("id",_currenId.value);
})

async function onLock() {
  if (!_selectedPeriod.value)
    return
  const id = await apiBordereau.lock(_selectedPeriod.value.id)
  if (id) {
    notificationService.success("Periode wurde geschlossen")

  }
  _listComponent.value?.refresh()
}

async function onUnlock() {
  notificationService.showYesNo("Periode Öffnen", "Möchten Sie wirklich die Periode öffnen", async () => {
    if (!_selectedPeriod.value)
      return
    const id = await apiBordereau.unlock(_selectedPeriod.value.id)
    if (id) {
      notificationService.success("Periode wurde geöffnet")
    }
    _listComponent.value?.refresh()
  })
}

async function onProgressRefresh(group: string, progressInfo: ProgressInfo) {
  _progressInfo.value = progressInfo
  if (progressInfo) {
    if (progressInfo.finishDate) {
      await progressService.removeFromGroup([progressInfo.groupId ?? ""], onProgressRefresh)
      if (!progressInfo.successful) {
        notificationService.error(progressInfo.resultMessage ?? "")
      } else {
        if (progressInfo.resultId) {
          _listComponent.value?.refresh()
          await apiFile.downloadFile(progressInfo.resultId)
          if (_params.ftp) {
            await apiBordereau.sendMail(_params.periodId, progressInfo.resultId)
          }
        }
      }
      _progressInfo.value = undefined
    }
  }
}

function onSelected(period?: BordereauPeriod) {
  _selectedPeriod.value = period
}

function onRefresh() {
  _listComponent.value?.refresh()
}

const _isWakam = computed(()=>{
  return (_bordereauId.value === "bordereau_wakam_us_nato"||_bordereauId.value === "bordereau_wakam")
})

const _isCsvExportVisible = computed(()=>{
  return _selectedPeriod.value && _isWakam.value
})

const _isUploadVisible = computed(()=>{
  return _isWakam.value&&_selectedPeriod.value && _selectedPeriod.value.closedDate
})

const _isPeriodClosVisible = computed(()=>{
  return _isWakam.value&&_selectedPeriod.value&&!_selectedPeriod.value.closedDate
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { title: "Bordereau-Perioden" }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogDropDownList, {
                modelValue: _bordereauId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_bordereauId).value = $event)),
                style: {"width":"140px"},
                name: "PartnerShipID",
                "data-source": _items
              }, null, 8, ["modelValue", "data-source"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Search,
                onClick: onRefresh
              }, null, 8, ["kind"]),
              _withDirectives(_createVNode(SogCardActionButton, {
                tooltip: "Periode schließen",
                "mdi-icon": "mdi-lock",
                onClick: onLock
              }, null, 512), [
                [_vShow, _isPeriodClosVisible.value]
              ]),
              _withDirectives(_createVNode(SogCardActionButton, {
                tooltip: "Periode öffnen",
                "mdi-icon": "mdi-lock-open-variant",
                onClick: onUnlock
              }, null, 512), [
                [_vShow, _isWakam.value && _selectedPeriod.value && _selectedPeriod.value.closedDate]
              ]),
              _withDirectives(_createVNode(SogCardActionButton, {
                tooltip: "Excel-Export",
                "mdi-icon": "mdi-file-excel",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onExport(false,false)))
              }, null, 512), [
                [_vShow, _selectedPeriod.value]
              ]),
              _withDirectives(_createVNode(SogCardActionButton, {
                tooltip: "Csv-Export",
                "mdi-icon": "mdi-file-delimited",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onExport(true,false)))
              }, null, 512), [
                [_vShow, _isCsvExportVisible.value]
              ]),
              _withDirectives(_createVNode(SogCardActionButton, {
                tooltip: "Upload an Wakam",
                "mdi-icon": "mdi-upload",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onExport(true,true)))
              }, null, 512), [
                [_vShow, _isUploadVisible.value]
              ]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogProgressInfoComponent, {
                "progress-info": _progressInfo.value,
                "show-caption": false
              }, null, 8, ["progress-info"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(BordereauListComponent, {
                ref_key: "_listComponent",
                ref: _listComponent,
                "bordereau-id": _bordereauId.value,
                onSelected: onSelected
              }, null, 8, ["bordereau-id"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})